"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validateEmail;

var _validateFormat = _interopRequireDefault(require("./validateFormat"));

function validateEmail(v, fields, options) {
  var _ref = options || {},
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? 'invalid email' : _ref$message;

  var regex = new RegExp('^\\S+@\\S+.\\S+$');
  var type = 'email';
  v = (0, _validateFormat["default"])(v, fields, {
    withFormat: regex,
    message: message,
    type: type
  });
  return v;
}